$(document).ready(() => {

	//// Criptografar cartão Pag Seguro
	// encrypt_card();
	// function encrypt_card() {
	//   var card = PagSeguro.encryptCard({
	//     publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB",
	//     holder: "Nome Sobrenome",
	//     number: "4111111111111112",
	//     brand: "visa",
	//     expMonth: "12",
	//     expYear: "2030",
	//     securityCode: "123"
	//   });
	//   var encrypted = card.encryptedCard;
	//   console.log(card);
	//   console.log(encrypted);
	// }

});